import BaseController from "./base_controller"

// Connects to data-controller="progress-bar"
export default class extends BaseController {
  static values = { percentage: Number }

  declare percentageValue: number

  connect(): void {
    super.connect()
    this.animateProgress()
  }

  private animateProgress(): void {
    const progressBar = this.element.querySelector<HTMLElement>('.progress')
    if (progressBar) {
      // Start from 0 and animate to target
      progressBar.style.width = '0%'
      
      // Animate with easing
      setTimeout(() => {
        progressBar.style.transition = 'width 1s ease-out'
        progressBar.style.width = `${this.percentageValue}%`
      }, 100)
    }
  }

  percentageValueChanged(): void {
    this.animateProgress()
  }
}

